import { useDecision } from '@optimizely/react-sdk';

export function useQuickPicksAlwaysShown(): boolean {
  const [decision, clientReady] = useDecision('quick_picks_always_shown');
  return clientReady && decision.enabled && decision.variationKey === 'on';
}
